var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { FloatingErrorContext } from './common/floating-error';
export const useAxiosGet = () => {
    const controller = new AbortController();
    const [loadingCount, setLoadingCount] = useState(-1);
    const setCurrentError = useContext(FloatingErrorContext);
    const fetch = (url_1, ...args_1) => __awaiter(void 0, [url_1, ...args_1], void 0, function* (url, delay = 0, errorKey = 'sa.errors.load_error', options = undefined) {
        setLoadingCount(loading => Math.max(loading + 1, 1));
        try {
            const { data } = yield axios.get(url, Object.assign(Object.assign({}, options), { signal: controller.signal }));
            const delaydData = yield new Promise(resolve => setTimeout(() => resolve(data), delay));
            setLoadingCount(loading => loading - 1);
            return delaydData;
        }
        catch (err) {
            if (!controller.signal.aborted)
                setCurrentError(errorKey);
            setLoadingCount(loading => loading - 1);
            return null;
        }
    });
    useEffect(() => () => controller.abort(), []);
    return [fetch, loadingCount !== 0];
};
//# sourceMappingURL=hooks.js.map